export default {
	inquirypcpage: '/inquiry/inquirypcpage', //网站询盘列表
	inquiryDetails: '/inquiry/details/{id}/{type}',
	inquiryTrend: '/inquiry/inquiryheaddiagram', //询盘趋势
	inquiryEntry: '/inquiry/inquiryentrance', //询盘入口统计
	inquiryIndustry: '/inquiry/inquiryindustry', //询盘行业统计
	inquiryRegion: '/inquiry/inquiryregion', //询盘地区统计
	inquiryService: '/inquiry/inquiryservice', //询盘服务单统计
	inquiryExport: '/inquiry/downlistinquiry', // 询盘导出
	getwebsiteorder: '/site/sitedomain/', // 获取网建订单信息
	inquiryList: '/email/inquiry/page', // 询盘分页列表
	inquiryDetail: '/email/inquiry/detail/{id}/{inquiryType}', // 询盘详情
	checkInquiry: '/email/inquiry/operation', // 审核接口
	addInquiryLabel: '/email/inquiry/addinquirylabel', // 添加询盘标签
	cancellationFilter: '/email/inquiry/revokefilter/{id}/{inquiryType}', // 撤销过滤
	reviewfail: '/email/inquiry/reviewfail', // 审核不通过
	reviewadopt: '/email/inquiry/reviewadopt/{id}/{inquiryType}', // 审核通过
	auditPass: '/email/inquiry/examinefail',
	inquiryTranslate: '/inquiry/translate/{id}/{type}', // 询盘翻译

	// 二次审核
	inquirySecondReview: '/inquiry/details/2nd/{summaryId}', // 获取询盘二次审核详情
	inquirySecondReviewAudit: '/inquiry/audit/2nd/{id}', // 询盘二次审核
	inquirySecondReviewGarbageAudit: '/inquiry/audit/garbage/2nd/{id}', // 垃圾询盘二次审核
};
